/* eslint-disable max-len */
import PATHS from "./routePaths";

export default {
  campaign: (import.meta.env.FOOJI_CAMPAIGN_KEY as string) ?? "test-gifting",
  destinationMarker: {
    image: "https://emojis.fooji.com/1f60e.svg",
    width: 50,
    height: 50
  },
  pickupMarker: {
    image: "https://emojis.fooji.com/1f3ea.svg",
    width: 50,
    height: 50
  },
  courierMarker: {
    image: "https://emojis.fooji.com/1f381.svg",
    width: 50,
    height: 50
  },
  v2: {
    flow: [
      // FIXME: We should move this to the demo file. There should be no default flow in live (non-demo/edit) code.
      {
        id: "landing",
        path: "/",
        public: true,
        requiresAuth: false,
        component: "Landing"
      },
      {
        id: "uploadFile",
        path: "/upload-file",
        public: false,
        requiresAuth: true,
        component: "UploadFile"
      },
      {
        id: "secondaryChannelAuth",
        path: PATHS.SECONDARY_CHANNEL,
        requiresAuth: true,
        public: false,
        component: "SecondaryChannelAuth"
      },
      {
        id: "ageCheck",
        path: PATHS.CHECK_AGE,
        requiresAuth: true,
        public: false,
        component: "CheckAge"
      },
      {
        id: "user",
        path: PATHS.USER_DETAILS,
        requiresAuth: true,
        public: false,
        component: "UserDetails"
      },
      {
        id: "address",
        path: PATHS.ADDRESS,
        requiresAuth: true,
        public: false,
        component: "AddressDetails"
      },
      {
        id: "skillTest",
        path: PATHS.SKILL_TEST,
        requiresAuth: true,
        public: false,
        component: "SkillTest"
      },
      {
        id: "chooseItem",
        path: PATHS.MENU,
        requiresAuth: true,
        public: false,
        component: "Menu"
      },
      // Commented out to facilitate tests, uncomment to restore localhost demo surveys
      // {
      //   id: "survey",
      //   path: PATHS.SURVEY,
      //   requiresAuth: false,
      //   public: true,
      //   component: "Survey"
      // },
      {
        id: "review",
        path: PATHS.REVIEW_DETAILS,
        requiresAuth: true,
        public: false,
        component: "Review"
      },
      {
        id: "verifyEmail",
        path: PATHS.VERIFY_EMAIL,
        requiresAuth: true,
        public: false,
        component: "VerifyEmail"
      },
      {
        id: "remind",
        path: PATHS.REMINDER,
        requiresAuth: true,
        public: false,
        component: "Reminder"
      },
      {
        id: "entryGate",
        path: PATHS.ENTRY_GATE,
        requiresAuth: true,
        public: false,
        component: "EntryGate"
      },
      {
        id: "progress",
        path: PATHS.PROGRESS,
        requiresAuth: true,
        public: false,
        component: "Progress"
      }
    ]
  },
  title: "Participate in the campaign, powered by Fooji",
  routes: {
    uploadFile: {
      headerCopy: "Upload $fileType",
      subHeaderCopy: "Please upload $fileMaxSizeCopy.",
      continueButtonCopy: "Continue",
      maxFileSizeErrorCopy: "File size exceeds $fileSizeMB. Please select a smaller file.",
      invalidFileErrorCopy: "Invalid file type. Please select a valid $fileType file.",
      selectFileButtonCopy: "Select a file",
      updateFileButtonCopy: "Update file",
      skipButtonCopy: "Skip"
    },
    shareAndVisit: {
      shareCopy: "Share with friends",
      visitCopy: "Visit Fooji"
    },
    info: {
      headerCopy: "Campaign info",
      subHeaderCopy: false,
      customHtml: "<p>Powered by Fooji, Inc.</p>"
    },
    extraInfo: {
      headerCopy: "Extra Campaign info",
      subHeaderCopy: false,
      customHtml: "<p>Powered by Fooji, Inc.</p>"
    },
    landing: {
      headerCopy: "Let's get started",
      subHeaderCopy:
        "You're only a few clicks away! We just need a couple of details to complete" + " your campaign entry",
      startButtonCopy: "Start"
    },
    socialGiftingLanding: {
      headerCopy: "A gift for you",
      subHeaderCopy:
        "We want to send you a token of appreciation! Simply fill in your details on this " +
        "site and we'll deliver your gift in three to five days",
      startButtonCopy: "Start"
    },
    vote: {
      headerCopy: "Vote",
      voteButtonCopy: "vote"
    },
    review: {
      stepTitleCopy: "Review information",
      headerCopy: "Confirm your details",
      buttonCopy: "Enter now",
      userCardHeaderCopy: "Personal information",
      selectedGiftHeaderCopy: "Your gift",
      customHtml: false
    },
    address: {
      stepTitleCopy: "Add delivery address",
      headerCopy: "Delivery details",
      subHeaderCopy: false,
      extraCopy: false,
      mapOverlayCopy: "Add address to see on map",
      markerEmoji: "https://emojis.fooji.com/1f60e.svg",
      addressPlaceholder: "Enter your address",
      address2Placeholder: "Apt/Suite/Floor",
      notePlaceholder: "Delivery instructions",
      newAddressButtonText: "New address",
      updateAddressButtonText: "Update address",
      chooseAddressButtonText: "Use address",
      buttonText: "Next",
      changeAddressButtonText: "Change address",
      confirmSelectedAddressButtonText: "Confirm",
      chooseFromSavedAddressesButtonText: "Select from saved",
      newAddressSelectionError: "Please select an address from the autocomplete list to advance",
      invalidAddressMessage: "Please enter a valid street address including the house number",
      noAddressesFoundText: "No addresses found",
      noContactDelivery: "No-contact delivery",
      addressLabel: "Delivery address",
      addressCardHeaderCopy: "Delivery information",
      deliveryTypeLabel: "Delivery type",
      deliveryInstructionsLabel: "Delivery instructions",
      normalDeliveryType: "Normal delivery",
      noContactDeliveryType: "No-contact delivery",
      disableNoContact: false,
      videoId: false,
      address1Placeholder: "Street",
      cityPlaceholder: "City",
      statePlaceholder: "State",
      zipPlaceholder: "Postal code",
      countryPlaceholder: "Country",
      address1Empty: "Please enter a valid street address including the house number",
      address1Invalid: "Please enter a valid street address including the house number",
      cityEmpty: "Please enter a valid city",
      cityInvalid: "Please enter a valid city",
      stateEmpty: "Please enter a valid state",
      stateInvalid: "Please enter a valid state",
      zipEmpty: "Please enter a valid zip code",
      zipInvalid: "Please enter a valid zip code",
      countryEmpty: "Please enter a valid country",
      countryInvalid: "Please enter a valid country"
    },
    campaignOver: {
      headerCopy: "sorry",
      subHeaderCopy: "We're all out!",
      showHelpLink: true
    },
    campaignTeaser: {
      headerCopy: "Not yet",
      subHeaderCopy: "Check back soon for your chance to win."
    },
    cancelled: {
      headerCopy: "uh oh",
      subHeaderCopy: "It looks like something went wrong.",
      retryText: "Click here to try again..."
    },
    chooseItem: {
      stepTitleCopy: "Select Gift",
      headerCopy: "What should we send?",
      orderButtonCopy: "Continue",
      unavailableCopy: "Unavailable",
      selectOption: "Select option",
      customHtml: false
    },
    deliveryZones: {
      subHeaderCopy:
        'We only have availability inside the <span style="border: 2px solid #60861f; ' +
        "padding: 5px; background-color: #B0C38F; " +
        'color: #000; font-weight: bold">green</span> zones.'
    },
    error: {
      headerCopy: "whoa",
      subHeaderCopy: "Demand is crazy right now! Give us a few minutes and try again.",
      tryAgainLink: "click here to to try again...",
      needHelpLink: "need help?",
      showHelpLink: true
    },
    invalidChannel: {
      headerCopy: "Invalid channel",
      subHeaderCopy: false
    },
    home: {
      headerCopy: "welcome",
      buttonText: "Get started with Twitter"
    },
    layout: {
      poweredByFooji: "Powered by Fooji",
      helpLinkCopy: "Help",
      changeLanguageLinkCopy: "Change language",
      footerCopy: false,
      gdprLinkCopy: "GDPR",
      termsLinkCopy: "Terms",
      rulesLinkCopy: "Rules",
      privacyLinkCopy: "Privacy",
      contactSupportCopy: "Contact Support",
      backButtonCopy: "Back"
    },
    noOojiData: {
      headerCopy: "Oh no",
      subHeaderCopy: "Something went wrong. Please try following the link you received again.",
      showHelpLink: true
    },
    noSupport: {
      headerCopy: "Out of area",
      subHeaderCopy:
        "We're sorry, but it looks like delivery service isn't available in your location. We appreciate your understanding.",
      checkAvailabilityLink: "You can check availability here",
      showHelpLink: true
    },
    progress: {
      headerCopy: "Track your gift",
      orderDetailsCopy: "Order Details"
    },
    remind: {
      stepTitleCopy: "Reminder",
      headerCopy: "don't miss it",
      subHeaderCopy: "Text me when the show is about to start.",
      yesCopy: "YES",
      noCopy: "NO",
      showLegalDisclaimer: true,
      customLegalDisclaimerCopy:
        'By providing my mobile number and clicking the "Yes" button above, ' +
        "I am authorizing you to send me automated text / SMS messages from an automatic dialing system advising me " +
        "about the information regarding this promotion. I understand " +
        "I am not required provide my number for the purposes " +
        "of receiving SMS message or enter into this agreement as a condition of participation. " +
        "Standard text and data rates may apply. See Terms for more details.",
      buttonCopy: "Next"
    },
    skillTest: {
      headerCopy: "skill test",
      continueButtonCopy: "Continue"
    },
    linkedInStart: {
      stepTitleCopy: "LinkedIn Login",
      headerCopy: "Sign in with LinkedIn",
      startButtonCopy: "Sign in"
    },
    secondaryChannelAuth: {
      headerCopy: "Authenticate with one of the following partners",
      subHeaderCopy: "Click on one of the partners below in order to participate in this campaign",
      linkedInStartButtonCopy: "Sign in with LinkedIn",
      twitchStartButtonCopy: "Sign in with Twitch",
      youtubeStartButtonCopy: "Sign in with YouTube",
      callOfDutyStartButtonCopy: "Sign in with Call of Duty",
      youtubeErrorMessage:
        'Sorry, that Google account has no associated YouTube channels. Need help? Click <a href="https://support.google.com/youtube/answer/1646861?hl=en">here</a> for support.'
    },
    stockOut: {
      headerCopy: "You just missed it",
      subHeaderCopy:
        "We're sorry, but it looks like we've already run out of prizes! We appreciate your understanding and hope to make you a winner next time.",
      showHelpLink: true
    },
    commonSuccess: {
      showFanPortal: true,
      fanPortalCopy: "Get tracking for your prize and more at the Fan Portal:"
    },
    success: {
      headerCopy: "You've won!",
      subHeaderCopy: "Congrats on your win! We're preparing you prize now.",
      showFulfillment: true,
      showPromoCode: false,
      deliveryEstimateLabelCopy: "Estimated delivery date and time:",
      deliveryEstimateCopy: "Within 2 hours",
      fulfillmentPartnerLogo: "/ooji/img/kanga.png",
      fulfillmentLabelCopy: "Fulfilled by",
      trackYourGiftButtonCopy: "Track your gift",
      customHtml: false
    },
    digitalSuccess: {
      headerCopy: "Congratulations!",
      subHeaderCopy: "Here is your reward code: ",
      showPromoCode: true,
      promoCodeLinkCopy: "Click here to redeem"
    },
    manualSuccess: {
      headerCopy: "You've won!",
      subHeaderCopy: "We're working on your prize now."
    },
    postalSuccess: {
      headerCopy: "You've won!",
      subHeaderCopy: "Congrats on your win! We're preparing you prize now.",
      deliveryEstimateLabelCopy: "You can expect it in the mail.",
      deliveryEstimateCopy: "Within 7-10 business days.",
      showFulfillment: true
    },
    verifyEmail: {
      stepTitleCopy: "Verify email",
      headerCopy: "verify your email",
      subHeaderCopy: "your email address needs to be verified for this promo",
      verifyButtonCopy: "Verify your email",
      emailSent:
        "We have sent a verification email to {email}. Click the link then come back to this page and " +
        "you should be able to proceed after a few seconds."
    },
    alreadyOrdered: {
      headerCopy: "Whoa",
      subHeaderCopy:
        "We detected you've already won and have an order on the way! " + "If you have questions dm @gofoojihelp!",
      extraCopy:
        '<a href="https://3719b8e5-bbb2-48ec-b39b-d4eb747db867.' +
        "prod12-care.sprinklr.com/articles/twitter-promos-faq/" +
        'received-whoa-youve-already-won-message/63ee9bc214faf7136098af4c">What does this mean?</a>'
    },
    suppliersClosed: {
      headerCopy: "sorry",
      subHeaderCopy: "All the merchants in your area are currently closed.",
      showHelpLink: true
    },
    tooMuchDemand: {
      headerCopy: "whoa",
      subHeaderCopy: "Demand is crazy right now. keep trying!",
      retryText: "click here to try again...",
      showHelpLink: true
    },
    ageCheck: {
      stepTitleCopy: "Age Gate",
      headerCopy: "How old are you?",
      invalidDOBAlert: "The date of birth you have entered is invalid. Please enter a valid date.",
      ageLimit: 21,
      continueButtonCopy: "save and continue"
    },
    rateLimit: {
      headerCopy: "Take a breather",
      subHeaderCopy: "It looks like you’ve tried to enter the campaign too many times within the past several minutes."
    },
    rateLimitWithCountdown: {
      headerCopy: "Take a breather",
      subHeaderCopy: "It looks like you’ve tried to enter the campaign too many times within the past several minutes.",
      retryText: "Please try the link again."
    },
    survey: {
      stepTitleCopy: "Survey",
      extraCopy: false,
      textSubHeaderCopy: "Write your answer below to continue placing your order.",
      headerCopy: false,
      subHeaderCopy: false,
      freeTextPlaceholder: "Answer here",
      customHtml: false,
      nextButtonCopy: "Next",
      choiceSubHeaderCopy: "Click one of the choices below to continue placing your order.",
      followUpSurveyThankYouCopy: "Thank you for your feedback!"
    },
    tooYoung: {
      headerCopy: "sorry",
      subHeaderCopy: "You must be of age to continue."
    },
    twitterAuthError: {
      headerCopy: "uh oh",
      subHeaderCopy: "It looks like your didn't manage to sign in.",
      retryText: "Please try the link again."
    },
    unlucky: {
      headerCopy: "bad luck",
      subHeaderCopy: "You didn't win.",
      allowRetry: true,
      buttonText: "Try again!"
    },
    user: {
      stepTitleCopy: "Personal information",
      headerCopy: "Enter your personal information",
      buttonText: "Next",
      firstNamePlaceholder: "First name",
      lastNamePlaceholder: "Last name",
      emailPlaceholder: "Email",
      phonePlaceholder: "Phone",
      twitterHandlePlaceholder: "Twitter handle without @ (for reminder)",
      disablePhone: false,
      preTertiaryCopy: "By clicking",
      tertiaryCopy:
        "I am authorizing you to send text messages, emails or phone calls " +
        "notifying me of delivery details for my order. " +
        "You may send the notice to the telephone number I have provided, " +
        "and I understand it will be sent using automatic dialing technology. " +
        "I understand that I am not required to agree to receive such " +
        "messages as a condition of my participation.",
      firstNameEmpty: "Please enter your first name",
      firstNameInvalid: "Your first name is too short",
      firstNameContainsIllegalCharacters: "Your first name contains illegal characters",
      lastNameEmpty: "Please enter your last name",
      lastNameInvalid: "Your last name is too short",
      lastNameContainsIllegalCharacters: "Your last name contains illegal characters",
      emailEmpty: "Please enter your email address",
      emailInvalid: "Please enter a valid email address",
      phoneEmpty: "Please enter your phone number",
      phoneInvalid: "Please enter a valid phone number",
      emailPatternInvalid: "Sorry, you must have an email address that ends with:",
      checkboxAlert: "some mandatory checkboxes need to be checked before proceeding",
      entryTokenPlaceholder: "Entry token",
      entryTokenEmpty: "Please enter the entry token",
      customFieldRequiredCopy: "This field is required",
      customFieldInvalidCopy: "This field is invalid"
    },
    customerInfo: {
      headerCopy: "your details?",
      buttonText: "Order now",
      firstNamePlaceholder: "First name",
      lastNamePlaceholder: "Last name",
      emailPlaceholder: "Email",
      phonePlaceholder: "Phone",
      preTertiaryCopy: "By clicking",
      tertiaryCopy:
        "I am authorizing you to send text messages, emails or phone " +
        "calls notifying me of delivery details for my order. " +
        "You may send the notice to the telephone number I have provided, and " +
        "I understand it will be sent using automatic dialing technology. " +
        "I understand that I am not required to agree to receive such messages as a condition of my participation.",
      checkboxAlert: "some mandatory checkboxes need to be checked before proceeding",
      newAddressButtonText: "New address",
      saveAddressButtonText: "Save address",
      addressPlaceholder: "Address",
      address2Placeholder: "Apt/Suite/Floor",
      notePlaceholder: "Delivery instructions",
      newAddressSelectionError: "Please select an address from the autocomplete list to advance",
      noContactDelivery: "No-contact delivery",
      disableNoContact: false,
      twitterHandlePlaceholder: "Twitter handle without @ (for reminder)",
      twitterHandleEmpty: "Please enter your twitter handle"
    },
    wait: {
      anonymousStartCopy: "Getting things ready...",
      availabilityCopy: "We're seeing if your area has coverage.",
      orderingCopy: "hold tight. nearly done!",
      errorCopy: "Sorry, this is taking longer than usual, please hold on...",
      rateLimitedCopy: "Sorry, but we're overloaded... It may take some time..."
    },
    linkUsed: {
      headerCopy: "Link already used",
      subHeaderCopy: "You have already ordered using this link 😔"
    },
    linkExpired: {
      headerCopy: "Link expired",
      subHeaderCopy: "Sorry, this link has expired. Please request a new link."
    },
    botDetected: {
      headerCopy: "Bot detected!",
      subHeaderCopy: "Our systems detected automated activity, which is a violation of the terms of service."
    },
    unsupportedBrowser: {
      headerCopy: "Unsupported browser",
      subHeaderCopy:
        "Our system has detected that you are using an outdated or unsupported browser. Please update your browser or switch to a supported version."
    },
    restrictedCampaignInfo: {
      headerCopy: "Restricted promo",
      subHeaderCopy: "This promo is restricted to users who have received a link directly."
    },
    store: {
      headerCopy: "Store"
    },
    entryGate: {
      stepTitleCopy: "Entry Gate",
      headerCopy: "Entry Gate",
      subHeaderCopy: "Please enter the required data",
      buttonCopy: "Continue",
      errorCopy: "There was an error validating your input. Please try again.",
      customHtml: false
    },
    authenticationError: {
      headerCopy: "Problem logging in",
      subHeaderCopy: "Sorry, we were unable to authenticate your account...",
      customHtml:
        '<br><br><a class="error-link" target="_blank" ' +
        'href="https://3719b8e5-bbb2-48ec-b39b-d4eb747db867.prod12-care.sprinklr.com' +
        "/articles/twitter-promos-faq/received-sorry-were-unable-to-authenticate-your-device-message/" +
        '63ee9bc214faf7136098af47">What should I do?</a>'
    },
    rules: {
      headerCopy: "Promotional Rules",
      subHeaderCopy: "Keep it safe",
      extraCopy: "<p>Extra rules information</p>",
      defaultRuleName: "Rule with no name",
      noRulesConfiguredCopy: "Oh no! No rules configured! 🙈🙊"
    },
    gdpr: {
      bannerCopy:
        "By clicking “Accept”, you agree to the storing of cookies on your device to enhance site" +
        " navigation, analyze site usage, and assist in our marketing efforts." +
        " View our privacy policy for more information.",
      bannerAcceptCopy: "Accept",
      bannerDenyCopy: "Deny",
      bannerPreferencesCopy: "Preferences",
      headerCopy: "Privacy preference center",
      subHeaderCopy:
        "We use cookies to provide the content and functionality of this website" +
        ", and subject to your consent, to analyze the use of our website and to ensure you" +
        " get the best experience. Third parties with whom we collaborate can also install" +
        " cookies in order to show you personalized advertisements on other websites." +
        " Read our cookie notice cookie notice for more information.",
      categoryHeaderCopy: "Manage consent preferences by category",
      categoryDescriptionCopy:
        "The use of the following cookies is not required to visit or browse our website," +
        " except for those that we use to provide the content and functionality of this site " +
        "(strictly necessary cookies). Blocking some types of cookies may impact your experience of the website" +
        " and the services we are able to offer. By clicking on the ACCEPT buttons listed in the options below, " +
        "you consent to our use of the associated category of cookies:",
      essentialHeaderCopy: "Essential",
      essentialDescriptionCopy:
        "These cookies are necessary for the Website to function and cannot be switched" +
        " off in our systems. They are usually only set in response to actions made by you which amount to a request" +
        " for services, such as setting your privacy preferences, logging in or filling in forms. You can set your" +
        " browser to block or alert you about these cookies, but some parts of the Website" +
        " will not work as they should. These cookies do not store any personal data.",
      performanceHeaderCopy: "Performance",
      performanceDescriptionCopy:
        "These cookies allow us to count visits and traffic sources so we can measure" +
        " and improve the performance of our Website. They help us to know which pages are the most and least" +
        " popular and see how visitors move around the Website and gather information on error messages." +
        " All information these cookies collect is aggregated and therefore anonymous. If you do not allow" +
        " these cookies we will not know when you have visited our Website," +
        " and will not be able to monitor its performance.",
      functionalHeaderCopy: "Functional",
      functionalDescriptionCopy:
        "These cookies enable the Website to provide enhanced functionality and" +
        " personalization. They may be set by us or by third party providers whose services we have added" +
        " to our pages. If you do not allow these cookies then some or all of these services may not" +
        " function properly.",
      targetingHeaderCopy: "Targeting",
      targetingDescriptionCopy:
        "These cookies record your visit to our Website, the pages you have visited" +
        " and the links you have followed. We will use this information to make our Website and the advertising" +
        " displayed on it more relevant to your interests. We may also share this information with third parties" +
        " for this purpose. These cookies may be set through our Website by our advertising partners." +
        " They may be used by those companies to build a profile of your interests and show you relevant adverts" +
        " on other websites. They do not store directly personal information, but are based on uniquely" +
        " identifying your browser and internet device. If you do not allow these cookies," +
        " you will experience less targeted advertising.",
      savePreferencesCopy: "Save Preferences",
      alwaysActiveCopy: "Always active"
    },
    404: {
      headerCopy: "Unknown page",
      subHeaderCopy: "Oops, how did you end up here?",
      buttonCopy: "Take me home"
    },
    emailVerified: {
      headerCopy: "Email verified",
      subHeaderCopy:
        "Your email has been validated successfully. " +
        "You can now continue the participation on the promo and close this tab."
    },
    emailVerificationFailed: {
      headerCopy: "Email verification failed",
      subHeaderCopy: "There was an error validating your email. Please try again."
    },
    invalidEntry: {
      headerCopy: "Invalid entry",
      subHeaderCopy: "Sorry, one of the requirements to enter this promotion was not met.",
      invalidEmailCopy: "Please enter a valid email address.",
      invalidTokenCopy:
        "The token entered is not valid. Please check you copied the token exactly, as it is case sensitive.",
      usedTokenCopy: "The token entered has already been used.",
      genericInvalidEntryCopy: "Please make sure to meet one of the requirements to enter this promotion."
    }
  },
  geo: {
    invalidAddressAlert: {
      title: "Oops, looks like we couldn't verify that address!",
      message: "Please try a couple different variations, and DM @gofoojihelp if you're still having issues."
    },
    error: {
      unableToLoadGoogleMapsCopy: "We were unable to load google maps :( Please try reloading the page.",
      allowGeolocationErrorCopy:
        "Please reload the page and allow geolocation of " + "your position, or enter the address manually.",
      disabledGeolocationErrorCopy:
        "You seem to have disabled geolocation, " + "please enable and retry, or enter the address manually."
    },
    loadTestAddress: {
      address_components: [
        {
          long_name: "100",
          short_name: "100",
          types: ["street_number"]
        },
        {
          long_name: "Wall Street",
          short_name: "Wall St",
          types: ["route"]
        },
        {
          long_name: "Manhattan",
          short_name: "Manhattan",
          types: ["sublocality_level_1", "sublocality", "political"]
        },
        {
          long_name: "New York",
          short_name: "New York",
          types: ["locality", "political"]
        },
        {
          long_name: "New York County",
          short_name: "New York County",
          types: ["administrative_area_level_2", "political"]
        },
        {
          long_name: "New York",
          short_name: "NY",
          types: ["administrative_area_level_1", "political"]
        },
        {
          long_name: "United States",
          short_name: "US",
          types: ["country", "political"]
        },
        {
          long_name: "10005",
          short_name: "10005",
          types: ["postal_code"]
        }
      ],
      formatted_address: "100 Wall St, New York, NY 10005, USA",
      geometry: {
        location: {
          lat: 40.7051415,
          lng: -74.00673859999999
        }
      },
      place_id: "ChIJvaAjHxZawokRmXyo5dmolpU"
    }
  },
  general: {
    fatalErrorCopy: "uh oh, something bad happened. try again later, and contact support if the problem persists 😢"
  },
  storage: {
    privateBrowsingError:
      "Oh oh, you seem to be blocking cookies, or running in " +
      "private browsing mode, Fooji will not function like that 😢"
  },
  api: {
    sessionExpired: "Sorry, your session has expired. Please login again.",
    unexpectedIssue: "Sorry, an unexpected issue occured"
  },
  kb: {
    mean: "what does this mean?",
    do: "what should I do?"
  },
  template: {
    textColor: "black",
    headerImg: "/ooji/img/fooji-icon.svg",
    headerImgAlt: "Fooji Inc heart eyes logo",
    backgroundImg: "/images/microsite-desktop-image.png",
    mobileBackgroundImg: "/images/microsite-mobile-image.png",
    backgroundImgAlt: "Fooji heart eyes surrounded by colourful shapes",
    backgroundOverlayOpacity: 1,
    emailFooter: "/ooji/img/email-footer.png",
    footerImg: "/ooji/img/fooji-icon.png",
    footerImgAlt: "Fooji Inc heart eyes logo",
    footerCopyrightCopy: "© Fooji, Inc. - Patent No. 11,488,233"
  }
};
